export default __webpack_public_path__ + "static/media/play.f2f5cc88.svg";